import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Students.css";
import InnerHeader from "../../components/InnerHeader";
import Card from "../../components/Card";
import { RiArrowUpDownFill, RiDeleteBin6Line } from "react-icons/ri";
import { FaEye } from "react-icons/fa";
import Popup from "../../components/Popup/Popup";
import AddTeam from "./AddTeam";
import SingleDropdown from "../../components/SingleDropdown";
import SearchInput from "../../components/SearchInput";
import Tooltip from "../../components/Tooltip";

import constant from "../../constant/constant";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SmallLoader from "../../components/SmallLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoMdMail } from "react-icons/io";

import SidePopup from "../../components/Popup/SidePopup";
import NoPermission from "../../components/NoPermission.js";
import { logout } from "../../store/authSlice.js";

const Students = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth);
  const limit = 10;

  const [students, setStudents] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [status, setStatus] = useState("");
  const [course, setCourse] = useState("");
  const [addTeamPopup, setAddTeamPopup] = useState(false);
  const [studentInfoPopup, setStudentInfoPopup] = useState(false);
  const [editedMember, setEditedMember] = useState(null);
  const [searchLabel, setSearchLabel] = useState("Search by");
  const [searchBy, setSearchBy] = useState("");
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [clearSignal, setClearSignal] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [userName, setUserName] = useState("");

  const [activeColumn, setActiveColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  
  const [filterStatus, setFilterStatus] = useState(false);
  const [dataStatus, setDataStatus] = useState(false);

  const [statusOptions, setStatusOptions] = useState([]);

  const [courseOptions, setCourseOptions] = useState([]);
  const [studentInfoData, setStudentInfoData] = useState([]);
  const [activeHistorySortColumn, setActiveHistorySortColumn] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const [autoLoader, setAutoLoader] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  //pagination
  const [isFetching, setIsFetching] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [totalPageNum, setTotalPageNum] = useState(0);
  // const pageRoleAccess = user.user_type;
  const pageRoleAccess = "company";
  

  const searchByOptions = [
    { label: "Name", value: "Name" },
    { label: "Email", value: "Email" },
    { label: "Mobile", value: "Mobile" },
  ];

  const handleSearchChange = (value) => {
    setSearchText(value);
  };

  const handleSearchByChange = (option) => {
    setSearchBy(option.value);
    setSearchLabel(option.label);
    setShowSearchInput(!!option.value);
    checkFiltersApplied(option.value, searchBy);
  };

  const handleStatusChange = (option) => {
    setStatus(option.value);
    checkFiltersApplied(option.value, course);
  };

  const handleCourseChange = (option) => {
    setCourse(option.value);
    checkFiltersApplied(status, option.value);
  };

  const checkFiltersApplied = (status, course) => {
    setFiltersApplied(
      status !== "" || course !== "" || searchBy !== "" || searchLabel !== ""
    );
  };

  const openAddStudentPopup = () => {
    setAddTeamPopup(true);
  };

  const handleDelete = (index, user_id) => {
    statusRejectOfUser(index, user_id);
  };

  const closeAddTeamPopup = () => {
    setAddTeamPopup(false);
    setEditedMember(null);
  };

  const handleClear = () => {
    setStatus("");
    setCourse("");
    setSearchBy("");
    setShowSearchInput(false);
    setClearSignal(true);
    let updatefilter = {
      ...listFilter,
      "searchtext": "",
      "searchByOptions":"",
      "courseStatus":"",
      "courseId": "",
    };
    setFiltersApplied(false);
    setListFilter(updatefilter);
    getStudentList();
  };

  const handleHeaderClick = (column) => {
    let newSortDirection = "asc";

    if (activeColumn === column) {
      newSortDirection = sortDirection === "asc" ? "desc" : "asc";
    } else {
      newSortDirection = "asc";
      setActiveColumn(column);
    }

    const sortedData = [...students].sort((a, b) => {
      if (a[column] < b[column]) return newSortDirection === "asc" ? -1 : 1;
      if (a[column] > b[column]) return newSortDirection === "asc" ? 1 : -1;
      return 0;
    });

    setStudents(sortedData);
    setSortDirection(newSortDirection);
  };

  const getHeaderProps = (column) => {
    const isActive = activeColumn === column;
    const isAsc = sortDirection === "asc";
    return {
      onClick: () => handleHeaderClick(column),
      headerClass: `cp box-center ${
        isActive ? (isAsc ? "fc3 asc" : "fc2 desc") : ""
      }`,
      iconClass: `cp ml4 ${isActive ? (isAsc ? "fc3 asc" : "fc2 desc") : ""}`,
    };
  };
  const [searchLead, setSearchLead] = useState("");
  const [courseStatus, setCourseStatus] = useState("");
  const [courseName, setCourseName] = useState("");

  const [listFilter, setListFilter] = useState(
    {
      "searchtext": "",
      "searchByOptions":"",
      "courseStatus":"",
      "courseId": "",
    }
  );

  const applyFilter = async () => {
    let updatefilter = {
      ...listFilter,
      "searchtext": searchText,
      "searchByOptions": searchBy,
      "courseStatus": status,
      "courseId": course,
    };
    setListFilter(updatefilter);
    setPageNum(1);
  };

  const getAllFilters = async () => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=getAllFilters`,
      headers: {"Auth-Id": user.auth_id },
      data: {}
    }).then(function (response) {
      checkUserLogin(response);
      const responseData = response.data.data.data;
      if (response.data.data.status === "1") {
        setStatusOptions(responseData.statusData);
        setCourseOptions(responseData.courseData);
        setFilterStatus(true);
      } else {
      }
    })
    .catch(function (error) {
    });
  }

  const statusRejectOfUser = async (index, student_id) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=statusRejectOfUser`,
      headers: {"Auth-Id": user.auth_id },
      data: {"student_id": student_id}
    }).then(function (response) {
      
      checkUserLogin(response);
      if (response.data.data.status === "1") {
        const updatedStudents = students.filter((_, i) => i !== index);
        setStudents(updatedStudents);
        toast.success(response.data.data.msg);
      } else {
        toast.error(response.data.data.msg);
      }
    })
    .catch(function (error) {
    });
  }

  const getStudentList = async () => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=getStudentList`,
      headers: {"Auth-Id": user.auth_id },
      data: {"page_num":pageNum,"limit":limit,"filter":listFilter}
    }).then(function (response) {
      checkUserLogin(response);
      const responseData = response.data.data;
      if (response.data.data.status === "1") {
        setStudents(responseData.data);
        setTotalCount(responseData.total);
        setDataStatus(true);
      } else {
        setStudents([]);
        setTotalCount(0);
      }
    })
    .catch(function (error) {
    });
  }

  const handleShowStatus = async(index, user_id) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=getShowStatus`,
      headers: {"Auth-Id": user.auth_id },
      data: {"student_id": user_id}
    }).then(function (response) {
      checkUserLogin(response);
      const responseData = response.data.data.data;
      if (response.data.data.status === "1") {
        setStudentInfoPopup(true);
        setStudentInfoData(responseData);
        if (sortConfig.key) {
          sortCourseHistoryData(sortConfig.key, sortConfig.direction);
        }
      } else {
        toast.warn("We couldn't find any history for this user in our records.");
      }
    })
    .catch(function (error) {
    });
  }

  const handleSentInvitationAgain = async(index, user_id, code) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/my_student.php?fun=SentInvitationAgain`,
      headers: {"Auth-Id": user.auth_id },
      data: {"student_id": user_id, "code":code}
    }).then(function (response) {
      checkUserLogin(response);
      if(response.data.data.status === "1"){
        toast.success(response.data.data.msg);
      } else {
        toast.warn(response.data.data.msg);
      }
    })
    .catch(function (error) {
    });
  }

  const handleHistorySortByChange = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setActiveHistorySortColumn(key);
    setSortConfig({ key, direction });
    sortCourseHistoryData(key, direction);
  }

  const sortCourseHistoryData = (key, direction) => {
    const sortedData = [...studentInfoData].sort((a, b) => {
      if (direction === "asc") {
        return a[key] > b[key] ? 1 : -1;
      } else {
        return a[key] < b[key] ? 1 : -1;
      }
    });
    setStudentInfoData(sortedData);
  };

  const handleStudentInfoPopupClose = () => {
    setStudentInfoData([]);
    setStudentInfoPopup(false);
  }
  const checkUserLogin = (response) => {
    if (response.data.login.status === 0) {
      dispatch(logout());
      navigate("/login");
    }
  };
  useEffect(() => {
    getAllFilters();
  },[]);

  useEffect(() => {
    const scrollHandler = () => {
      // Debouncing logic starts here
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const { scrollHeight, scrollTop, clientHeight } =
          document.documentElement;
        if (scrollTop + clientHeight >= scrollHeight - 70 && !isFetching) {
          setIsFetching(true);
          if (pageNum <= totalPageNum) {
            getStudentList();
          }
        }
      }, 200); // Adjust the debounce delay as needed
    };

    let scrollTimeout;

    window.addEventListener("scroll", scrollHandler);

    return () => window.removeEventListener("scroll", scrollHandler);
  }, [isFetching, pageNum]);

  useEffect(() => {
    getStudentList();
  },[listFilter]);

  return (
    <>
    {pageRoleAccess === "company" ? (
      <>
        <InnerHeader
          // heading="My Student"
          txtSubHeading="Explore the list of all team members registered under your company's account, including yourself. Use this section to manage your team details, add or remove members, and keep profiles updated."
          showButton={true}
          iconText="Add New Student"
          onClick={openAddStudentPopup}
        />
        <Card className="account-container bg1 mt16 p20 pb48">
          <div className="student-filter mb24 v-center fww">
            {statusOptions?.length > 0 && (
              <div className="status-filter mr12">
                <SingleDropdown
                  label="Select Status"
                  options={statusOptions}
                  selectedOption={statusOptions.find(
                    (option) => option.value === status
                  )}
                  onSelect={handleStatusChange}
                  noLabel={false}
                />
              </div>
            )}
            {courseOptions?.length > 0 && (
              <div className="course-filter mr12">
                <SingleDropdown
                  label="Select Course"
                  options={courseOptions}
                  selectedOption={courseOptions.find(
                    (option) => option.value === course
                  )}
                  onSelect={handleCourseChange}
                  noLabel={false}
                />
              </div>
            )}
            {(courseOptions?.length > 0 || statusOptions?.length > 0) && (
              <div className="search-by-filter mr12">
                <SingleDropdown
                  label="Search by"
                  options={searchByOptions}
                  selectedOption={searchByOptions.find(
                    (option) => option.value === searchBy
                  )}
                  onSelect={handleSearchByChange}
                  noLabel={false}
                />
              </div>
            )}
            {showSearchInput && (
              <div className="search-filter v-center mt8 mr12">
                <SearchInput
                  onSearchChange={handleSearchChange}
                  clearSignal={clearSignal}
                  placeholder={searchLabel}
                />
              </div>
            )}
            {filtersApplied && (
              <>
                <button className="bg3 fs12 pl12 pr12 pt8 pb8 fc1 cp br16 ls1 mr8 mt8" onClick={()=>applyFilter()}>
                  GO
                </button>
                <button
                  className="clear fs12 pl12 pr12 pt8 pb8 fc1 cp br16 ls1 fw6 mt8"
                  onClick={handleClear}
                >
                  Clear
                </button>
              </>
            )}
          </div>
          <div className="pl16 pt16 fww fs12 ">{"Total Results: "+totalCount}</div>
          <div
            className="joinde-course-list brd-t2 mt24 pt24 pb24"
            style={{ overflow: "auto" }}
          >
            <table className="student-table tac common-table wsnw">
              <thead>
                <tr>
                  <th {...getHeaderProps("name")} style={{ minWidth: "100px" }}>
                    <p className={getHeaderProps("name").headerClass}>
                      Name
                      <RiArrowUpDownFill
                        className={getHeaderProps("name").iconClass}
                      />
                    </p>
                  </th>
                  <th {...getHeaderProps("email")}>
                    <p className={getHeaderProps("email").headerClass}>
                      Email
                      <RiArrowUpDownFill
                        className={getHeaderProps("email").iconClass}
                      />
                    </p>
                  </th>
                  <th {...getHeaderProps("mobile")}>
                    <p className={getHeaderProps("mobile").headerClass}>
                      Mobile
                      <RiArrowUpDownFill
                        className={getHeaderProps("mobile").iconClass}
                      />
                    </p>
                  </th>
                  <th {...getHeaderProps("status")}>
                    <p className={getHeaderProps("status").headerClass}>
                      Last Course Status
                      <RiArrowUpDownFill
                        className={getHeaderProps("status").iconClass}
                      />
                    </p>
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {students.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="no-students-message">
                      <p className="fs14 fc6 ls1 lh18">No student is available</p>
                      <button
                        className="enroll-now-button btn-blue bg1 br24 fs14 cp pl16 pr16 pt10 pb10 fc1 ml32 ls2 mt16"
                        onClick={openAddStudentPopup}
                      >
                        Add Now
                      </button>
                    </td>
                  </tr>
                ) : (
                  students.map((student, index) => (
                    <tr key={index}>
                      <td className="leads-tool-fix"><Tooltip title={student.name}>
                              {student.name}
                            </Tooltip></td>
                      <td>{student.email}</td>
                      <td>{student.mobile}</td>
                      <td>
                        <span>
                          {student.status}
                        </span>
                      </td>
                      <td className="leads-tool-fix box-center">
                        {student.user_status !== "2" ? (
                          <Tooltip title="Course History">
                            <FaEye 
                              onClick={() => {
                                handleShowStatus(index, student.user_id);
                                setUserName(student.name);
                              }}
                              className="fs18 fc3 cp"
                            />
                          </Tooltip>
                        ) : (
                          ""
                        )}
                        
                        {student.email && student.email !== "--" ? (
                          <Tooltip title={student.user_status === "1" ? "Sent Invitation" : "Resend Invitation"}>
                            <IoMdMail 
                              onClick={() => {
                                handleSentInvitationAgain(
                                  index, 
                                  student.user_id,
                                  student.user_status === "1" ? 1 : 2
                                );
                              }}
                              className="fs18 fc3 cp ml8"
                            />
                          </Tooltip>
                        ) : null}
                        {student.user_status === "2" ? (
                          <Tooltip title="Delete User">
                            <RiDeleteBin6Line
                              onClick={() => handleDelete(index, student.user_id)}
                              className="fs18 fc3 cp ml8"
                            />
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {studentInfoPopup && (
            <SidePopup
              show={studentInfoPopup}
              onClose={handleStudentInfoPopupClose}
              className="full-width"
            >
              <div className="selected-plan-details">
                <div className="df jcsb profile-card-header brd-b1 p12 box-center bg7  w100 fc1 ls2 lh22">
                  <p className="fs18 fc2 ">{userName}'s Course History</p>
                  <button
                    onClick={() => {
                      setStudentInfoPopup(false);
                      document.body.style.overflow = "auto";
                    }}
                    className="lead-close-button"
                  >
                    X
                  </button>
                </div>
                <div className="booked p8">
                  <table className="ledger-table cp w100 wsnw">
                    <thead>
                      <tr>
                        <th>Course Name</th>
                        <th>Theory Batch</th>
                        <th>Flying Batch</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Training Center</th>
                        <th>Status</th>
                        {/* <th>
                          <p className="box-center">
                            Action
                          </p>
                        </th> */}
                      </tr>
                    </thead>
                    <tbody>
                    {studentInfoData.length > 0 ? (
                      studentInfoData.map((student, index) => {
                        return (
                          <tr key={index}>
                            <td>{student.course_name}</td>
                            <td>{student.batch}</td>
                            <td>{student.fly_batch}</td>
                            <td>{student.start_date}</td>
                            <td>{student.end_date}</td>
                            <td>
                              <div style={{ display: "block" }}>
                                {student.location_title}
                              </div>
                            </td>
                            <td><span>{student.status}</span></td>
                            {/* <td></td> */}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="15" style={{ textAlign: 'center' }}>
                          No records available
                        </td>
                      </tr>
                    )}
                    </tbody>
                  </table>
                </div>
              </div>
            </SidePopup>
          )}
          {addTeamPopup && (
            <Popup
              onClose={closeAddTeamPopup}
              title={editedMember ? "Update Student" : "Add Student(s)"}
              txtSubHeading={
                "Enter the student’s email to enroll them in our training program."
              }
            >
              <AddTeam onClose={closeAddTeamPopup} editedMember={editedMember} getStudentList={getStudentList} />
            </Popup>
          )}
        </Card>
      </>
    ) : (
      <NoPermission displayMsg={"No permission to access this page"} />
    )}
    <ToastContainer position="bottom-right" />
    </>
  );
};

export default Students;
